var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"layout-footer footer",class:_vm.getLayoutFooterBg()},[_c('div',{staticClass:"container-fluid container-p-x pb-3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }